export default "__VITE_ASSET__CS$KbENT__"